import { euOnlyInterceptor, jwtInterceptor } from '@23degrees/shared/interceptors';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode, mergeApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig, withViewTransitions } from '@angular/router';

import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { SimpleNotificationsModule } from 'angular2-notifications';

import { TranslationsLoader } from '@23degrees/apps/atlas/atlas.translate-loader';
import { loadingInterceptor } from '@23degrees/layout/services/loading/loading.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { routes } from './app.routes';
import { provide23init } from './app.providers';

let browserConfig: ApplicationConfig = { providers: [] };
const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // provideExperimentalZonelessChangeDetection(),
    importProvidersFrom(
      SimpleNotificationsModule.forRoot(),
      // HammerModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslationsLoader,
        },
        isolate: false,
      }),
    ),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
      withViewTransitions(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      // withPreloading(CustomPreloadingStrategy)
      // TODO: transition between pages can be adjusted here
      //   {
      //   onViewTransitionCreated(transitionInfo) {
      //     const router = inject(Router);
      //     const targetUrl = router.getCurrentNavigation()!.finalUrl;
      //       console.log({transitionInfo}, transitionInfo.from.url, transitionInfo.to.url, targetUrl)
      //   },
      // }
    ),
    provideClientHydration(
      // withEventReplay(),
      withIncrementalHydration(),
      // withHttpTransferCacheOptions({
      //   includePostRequests: true,
      //   includeRequestsWithAuthHeaders: true,
      //   filter: (req) => !req.url.endsWith('.svg'),
      // }),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        // transferStateInterceptor,
        jwtInterceptor,
        euOnlyInterceptor,
        loadingInterceptor,
      ]),
    ),
    provideAnimations(),

    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),

    provide23init()
  ],
};

if (isDevMode()) {
  browserConfig.providers.push(importProvidersFrom(AkitaNgDevtools.forRoot()));
}

browserConfig = mergeApplicationConfig(appConfig, browserConfig);

export { appConfig, browserConfig };
